import { h } from '@stencil/core';
import { StarRatingItem } from '../star-rating-item/star-rating-item';
export class StarRating {
  constructor() {
    this.generateId = () => (~~(Math.random() * 1e8)).toString(16);
    this.renderStarWrapper = (rate) => {
      const defsProps = null;
      const svgProps = { width: '0', height: '0', style: { position: 'absolute' } };
      const gradientProps = { id: `partialFilling_${this.partialId}` };
      return (h("svg", Object.assign({}, svgProps), h("defs", Object.assign({}, defsProps), h("linearGradient", Object.assign({}, gradientProps), h("stop", { "stop-opacity": "1", offset: `${(rate - parseInt(rate || 0, 10)) * 100}%`, "stop-color": this.starColor }), h("stop", { "stop-opacity": "1", offset: "0%", "stop-color": this.starBackground })))));
    };
    this.bazaarVoiceEnabled = undefined;
    this.ratingData = undefined;
    this.url = undefined;
    this.partialId = undefined;
    this.starSize = 15;
    this.starColor = '#ffd100';
    this.starBackground = '#cbcbcb';
  }
  renderItems() {
    const { rate, range } = this.ratingData || { rate: 0, range: 5 };
    const starClass = { class: 'star__color-filled' };
    const emptyStarClass = { class: 'star__color-empty' };
    const partialFilling = { fill: `url(#partialFilling_${this.partialId})` };
    const starsArray = [...new Array(range)];
    let integerPart = true;
    return starsArray.map((_, index) => {
      const filledStars = Math.floor(rate);
      if (index < filledStars && integerPart) {
        return StarRatingItem({ gProps: starClass, size: this.starSize });
      }
      if (integerPart) {
        integerPart = false;
        return StarRatingItem({ gProps: partialFilling, size: this.starSize });
      }
      return StarRatingItem({ gProps: emptyStarClass, size: this.starSize });
    });
  }
  componentWillLoad() {
    this.partialId = this.generateId();
  }
  render() {
    const { rate, totalQty } = this.ratingData || { rate: 0, totalQty: 0 };
    const rating = Number(rate).toFixed(1);
    return (this.bazaarVoiceEnabled && (h("a", { href: this.url, target: "_blank", rel: "noopener noreferrer", class: "product-rating" }, h("div", { class: "product-rating__wrapper" }, this.renderStarWrapper(rate), h("div", { class: "product-rating__inner-wrapper" }, this.renderItems())), h("span", { class: "product-rating__rating-count" }, rating), h("span", { class: "product-rating__review-count" }, "(", totalQty, ")"))));
  }
  static get is() { return "pes-star-rating"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["star-rating.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["star-rating.css"]
    };
  }
  static get properties() {
    return {
      "bazaarVoiceEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "bazaar-voice-enabled",
        "reflect": false
      },
      "ratingData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRatingData",
          "resolved": "{ totalQty?: number; rate?: number; range?: number; }",
          "references": {
            "TRatingData": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "url": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "url",
        "reflect": false
      },
      "partialId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "partial-id",
        "reflect": false
      },
      "starSize": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "star-size",
        "reflect": false,
        "defaultValue": "15"
      },
      "starColor": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "star-color",
        "reflect": false,
        "defaultValue": "'#ffd100'"
      },
      "starBackground": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "star-background",
        "reflect": false,
        "defaultValue": "'#cbcbcb'"
      }
    };
  }
}
